const AuthProvider = {
  name: 'AuthProvider',
  computed: {
    isAuthenticated () {
      return this.$store.getters['auth/isAuthenticated']
    },
    user () {
      return this.$store.getters['auth/user']
    },
    authToken () {
      return this.$store.getters['auth/authToken']
    },
    userId () {
      return this.$store.getters['auth/userId']
    }
  },
  provide () {
    return {
      $isAuthenticated: () => this.isAuthenticated,
      $user: () => this.user,
      $authToken: () => this.authToken,
      $userId: () => this.userId
    }
  },
  render () {
    return this.$slots.default
  }
}

export default AuthProvider
